module.exports = __webpack_public_path__ + "img/horizontal_3_6_3.cac8e0ed.png";